import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

export default function Menu() {
  const user = useSelector((state) => state.Login.user);
  const [menuItems, setMenuItems] = useState([]);
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (user?.id) {
      setMenuItems(user.models || []);
    }
  }, [user]);

  return (
    <aside
      className={`
        ${isMenuOpen ? 'block' : 'hidden'}
        lg:block
        h-screen w-64
        bg-cs-bg-alt
        border-r border-cs-border
        flex-shrink-0
      `}
    >

      {/* Menu */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {menuItems.map((item, index) => {
          const isActive =
            location.pathname === item.link ||
            item.associatedRoutes?.includes(location.pathname);

          return (
            <Link
              key={index}
              to={item.link}
              className={`
                group flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors
                ${
                  isActive
                    ? 'bg-cs-primary-soft text-cs-primary border-l-4 border-cs-primary'
                    : 'text-cs-dark hover:bg-cs-surface-alt'
                }
              `}
            >
              <span
                className={`
                  material-symbols-outlined text-base
                  ${isActive ? 'text-cs-primary' : 'text-cs-muted'}
                `}
              >
                {item.icon}
              </span>
              <span className="flex-1 truncate">
                {item.name}
              </span>
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="px-4 py-3 border-t border-cs-border text-xs text-cs-muted bg-cs-surface">
        Sistema administrativo
      </div>
    </aside>
  );
}
